import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="response-template"
export default class extends Controller {
  static targets = ["select"]

  connect() {
    this.templates = []
    this.loadTemplates()
  }

  loadTemplates() {
    const labelId = this.element.dataset.responseTemplateLabelValue || ""
    const url = labelId ? `/response_templates/search?label_id=${labelId}` : "/response_templates/search"
    
    fetch(url, {
      headers: { "Accept": "application/json" }
    })
    .then(response => response.json())
    .then(templates => {
      this.templates = templates
      this.populateSelect()
    })
    .catch(error => {
      console.error("Failed to load response templates:", error)
    })
  }

  populateSelect() {
    const select = this.selectTarget
    // Clear existing options except the placeholder
    while (select.options.length > 1) {
      select.remove(1)
    }
    // Add template options
    this.templates.forEach(template => {
      const option = document.createElement("option")
      option.value = template.id
      option.textContent = template.title
      select.appendChild(option)
    })

    // Hide the picker if there are no templates
    if (this.templates.length === 0) {
      this.element.style.display = "none"
    }
  }

  insert(event) {
    event.preventDefault()
    const templateId = this.selectTarget.value
    if (!templateId) return

    const template = this.templates.find(t => t.id === parseInt(templateId))
    if (!template) return

    // Insert into Froala editor
    const editorElement = document.querySelector('.fr-element.fr-view')
    if (editorElement) {
      editorElement.innerHTML = template.body
      // Trigger input event so Froala knows content changed
      editorElement.dispatchEvent(new Event('input', { bubbles: true }))
    }

    // Also set the hidden textarea in case Froala sync is needed
    const textarea = document.querySelector('textarea#content')
    if (textarea) {
      textarea.value = template.body
    }

    // Reset the select
    this.selectTarget.value = ""
  }
}
